import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoggedIn } from '../../../../features/account/account.slice';

const ConfirmVerificationCode = ({ verificationEmail, setVerificationEmail, closeModal, setServerMessage, refreshCookies, currentEmail, status }) => {
  const inputRefs = useRef([]); // Create a ref array for the inputs
  const [code, setCode] = useState(Array(6).fill("")); // Initialize with 6 empty strings
  const [isSubmitting, setIsSubmitting] = useState(false); // State to track submission status

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const dispatch = useDispatch();

  const handleInputChange = (e, index) => {
    const value = e.target.value;

    // Allow only digits
    if (!/^\d*$/.test(value)) {
      e.target.value = ''; // Clear invalid input
      return;
    }

    // Update the code array
    setCode((prevCode) => {
      const newCode = [...prevCode];
      newCode[index] = value;
      return newCode;
    });

    // Move to the next input if a value is entered
    if (value.length === 1 && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (inputRefs.current[index]) {
        if (inputRefs.current[index].value !== "") {
          inputRefs.current[index].value = "";
          setCode((prevCode) => {
            const newCode = [...prevCode];
            newCode[index] = "";
            return newCode;
          });
        } else if (index > 0) {
          inputRefs.current[index - 1]?.focus();
        }
      }
    } else if (e.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === 'ArrowRight' && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const submitCode = async (code) => {
    //API call to verify the code
    const response = await fetch(`${apiUrl}/api/user/verifyemail`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify({ 
        code: code, 
      }),
    });

    if (response.status === 401) {
      // Unauthorized, possibly session expired
      dispatch(setIsLoggedIn(false)); // Redux update will clear user data and redirect to login
      return;
    };

    const data = await response.json();

    if (data.success === true) {
      await refreshCookies();
      setServerMessage(data);
      closeModal();
    }
    else {
      setServerMessage(data);
    }
  }

  const resendCode = async () => {
    const response = await fetch(`${apiUrl}/api/user/resendverification`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
    })

    if (response.status === 401) {
      // Unauthorized, possibly session expired
      dispatch(setIsLoggedIn(false)); // Redux update will clear user data and redirect to login
      return;
    };

    const data = await response.json(); 

    if (data.success === true) {
      setServerMessage(data);
    }
    else {
      setServerMessage(data);
    }
  }

  const handleSubmit = async () => {
    const codeValue = code.join(''); // Combine the code into a single string
    await submitCode(codeValue); // Call the parent-provided onSubmit function
    // Clear the code input fields
    setCode(Array(6).fill("")); // Reset the code state
    setVerificationEmail(null); // Reset data in parent component
    closeModal(); // Close the modal
  };

  const isCodeComplete = code.every((digit) => digit !== ""); // Check if all inputs are filled

  return (
      <div className='d-flex flex-column w-100 rounded mt-4' style={{ padding: "0px" }}>
        <h4>Confirm your email</h4>
        <p style={{ fontSize: "16px", maxWidth: "625px" }}>A 6-digit code was sent to your email at {verificationEmail}. Enter it below to confirm your email.</p>
        <p style={{ fontSize: "16px", color: "#AEAFBA" }}>If you didn't receive the code, please check your spam folder or <span style={{ color: "#FFCC19", cursor: "pointer" }} onClick={resendCode}>click here</span> to resend it.</p>
        <div className='d-flex justify-content-between' style={{ marginBottom: "20px", marginTop: "0px" }}>
          {[...Array(6)].map((_, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              className="custom-input rounded"
              type="text"
              maxLength="1"
              placeholder=""
              onInput={(e) => handleInputChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              style={{
                width: "50px",
                height: "70px",
                backgroundColor: "#171A29",
                marginRight: index < 5 ? "10px" : "0px",
                textAlign: "center",
                lineHeight: "70px",
                fontSize: "24px",
                color: "white",
                border: "1px solid #3C3E4C",
                borderRadius: "5px",
                padding: "0px",
                cursor: "text",
              }}
            />
          ))}
        </div>
        <button 
          className='rounded w-100' 
          style={{ backgroundColor: isCodeComplete ? '#FFCC19' : '#CCC', height: "45px", fontWeight: 600 }} 
          onClick={handleSubmit}
          disabled={!isCodeComplete} // Disable button if code is not complete}
        >
          Confirm
        </button>
      </div>
  );
};

export default ConfirmVerificationCode;